import { render, staticRenderFns } from "./wtFilesDropzone.component.vue?vue&type=template&id=4f0ed83e&"
import script from "./wtFilesDropzone.component.vue?vue&type=script&lang=js&"
export * from "./wtFilesDropzone.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports